import React from 'react';
import classnames from 'classnames';
import { CustomisationLocation } from 'src/components/CustomisationPage/CustomisationLocation';
import { ProductLocation } from 'src/components/CustomisationPage/feature/customisation.types';

import classes from './ProductLocations.scss';

type Props = {
    locations: ProductLocation[];
    borderless?: boolean;
    newGrid?: boolean;
};

export const ProductLocations: React.FC<Props> = (props) => {
    const { borderless, locations, newGrid } = props;
    return (
        <div className={classes.productLocations}>
            {locations.map((location) => {
                return (
                    <div
                        key={location.name}
                        className={classnames(classes.productLocationsItem, {
                            [classes.productLocationsItemBorderless]: borderless,
                            [classes.newGrid]: newGrid,
                        })}
                    >
                        <CustomisationLocation image={location.image_url} title={location.name} />
                    </div>
                );
            })}
        </div>
    );
};
